import gameInitialState from "./gameInitialState"

const initialState = {
  ...gameInitialState,
}

export default initialState
